import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  includedAuthors: insights.map((insight) => ({
    name: insight.name || insight.authorName,
    authorName: insight.name ? undefined : insight.authorName,
    authorID: insight.authorID,
    domain: insight.domain
  }))
})

const generateAuthorsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateAuthorsInsightStrategy
